import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  // const otpVerified = localStorage.getItem("otp_verified") === "true";

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          // otpVerified ? (
            <Component {...props} />
          // ) : (
          //   <Redirect to="/auth/verify-otp" />
          // )
        ) : (
          <Redirect to="/auth/signin" />
        )
      }
    />
  );
};

export default PrivateRoute;
